module.exports = __webpack_public_path__ + "2267d20fd89c81a461e38abecdb8fcdc.js";